const responsiveCellHeaders = tables => {
  [...tables].forEach( (table, currentTableIndex) => {
    table.setAttribute( 'id', `table-${currentTableIndex}` );
    table.setAttribute( 'tabindex', '0' );

    const tableHeaders = Array.from( table.querySelectorAll( "th" ) ).map( th => th.innerHTML );

    const styleElm = document.createElement( "style" );
    document.head.appendChild( styleElm );
    const styleSheet = styleElm.sheet;
    tableHeaders.forEach( (headingText, index) => {
      styleSheet.insertRule( `#${table.id} td:nth-child(${index + 1})::before {content: "${headingText}: ";}`, styleSheet.cssRules.length );
    } );
  } );
};

const addTableARIARoles = tables => {
  [...tables].forEach( table => {
    const allRowGroups = table.querySelectorAll( 'thead, tbody, tfoot' );
    const allRows = table.querySelectorAll( 'tr' );
    const allCells = table.querySelectorAll( 'td' );
    const allHeaders = table.querySelectorAll( 'th' );
    const allRowHeaders = table.querySelectorAll( 'th[scope=row]' );

    allRowHeaders.forEach( (rowHeader) => rowHeader.setAttribute( 'role', 'rowheader' ) );
  } );
};

const tables = allTables => {
  if (!allTables) {
    return;
  }

  responsiveCellHeaders( allTables );
  addTableARIARoles( allTables );
};

export default tables;